import { connect } from 'react-redux';
import React from 'react';
import routerActions from 'app/routerActions';
import { bindActionCreators } from 'redux';
import { apiCallFailure } from 'app/actions';
import { api } from 'app/services';
import { KBPagination, KBTableWithoutData } from 'components';
import dayjs from 'utils/dayjs';
import { getServiceErrorMessage, paginate } from 'utils/kbUtil';
import { ArrowRightOutlined } from '@ant-design/icons';
import SettingCoupon from './SettingCoupon';

var MeetingCoupon = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.getList = this.getList.bind(this);this.updateCoupon = this.updateCoupon.bind(this);this.goToDetail = this.goToDetail.bind(this);}getInitialState()

  {
    const { params = {}, page } = this.props;
    return {
      loc_id: params.id,
      coupons: [],
      pagination: {
        page,
        per_page: 10 },

      modalVisible: false,
      currentData: {} };

  }getList(

  params) {
    api.getCoupon(params).then(res => {
      const { json } = res;
      let pagination = paginate(res.response);
      this.setState({ coupons: json, pagination });
    });
  }componentDidMount()

  {
    const { pageType } = this.props;
    const { loc_id, pagination } = this.state;
    this.getList({
      location_id: loc_id,
      discount_for: pageType === 'coupon' ? 'meeting_room' : 'flexible_office',
      ...pagination });

    // api.getCoupon()
  }componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      this.getList({
        location_id: this.state.loc_id,
        discount_for:
        this.props.pageType === 'coupon' ? 'meeting_room' : 'flexible_office',
        ...this.state.pagination,
        page: this.props.page });
    }
  }updateCoupon(

  id, params, type) {
    const { pageType, apiCallFailureActions } = this.props;
    const { loc_id, pagination } = this.state;
    api.updateCoupon(id, params).then(
    res => {
      const Params = {
        location_id: loc_id,
        discount_for:
        pageType === 'coupon' ? 'meeting_room' : 'flexible_office',
        ...pagination };

      if (type === 'edit') {
        this.setState({ modalVisible: false }, () => {
          this.getList(Params);
        });
      } else {
        this.getList(Params);
      }
    },
    err => {
      apiCallFailureActions({
        status: 'error',
        message: getServiceErrorMessage(err) || err.message });
    });

  }goToDetail(

  id) {
    const { pageType, routerActions } = this.props;
    const { loc_id } = this.state;
    if (pageType === 'coupon') {
      routerActions.push(
      `/admin/locations/${loc_id}/meetingCoupon/detail?coupon_id=${id}&&type=coupon`);

    } else {
      routerActions.push(
      `/admin/locations/${loc_id}/meetingCoupon/detail?coupon_id=${id}&&type=areacoupon`);

    }
  }render()

  {
    const { pageType } = this.props;
    const {
      coupons,
      currentData,
      modalVisible,
      pagination,
      loc_id } =
    this.state;
    const pageTemplate =
    pageType === 'coupon' ?
    `/admin/locations/${loc_id}/meeting/coupon?page=#PAGE#` :
    `/admin/locations/${loc_id}/areas/areacoupon?page=#PAGE#`;

    return (
      <div className="kb-content" style={{ paddingTop: 0 }}>
        <section
        className={`${
        pageType === 'coupon' ?
        'nav-section-container f-right' :
        'kb-content-container'
        }`}>

          <header
          className={`${
          pageType === 'coupon' ? 'nav-section-header' : 'nav-header'
          }  clear-fix`}
          style={{ position: 'relative' }}>

            <h2 className="nav-section-header-title f-left">
              <span>优惠管理</span>
            </h2>
          </header>
          <div>
            <table className="content-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ minWidth: 100 }}>
                    {pageType === 'coupon' ? '会议室名称' : '灵活工位名称'}
                  </th>
                  <th style={{ minWidth: 80 }}>创建人</th>
                  <th style={{ minWidth: 80 }}>优惠名称</th>
                  <th style={{ minWidth: 100 }}>优惠活动时间</th>
                  <th style={{ minWidth: 100 }}>
                    价格（元/{pageType === 'coupon' ? '时' : '天'}）
                  </th>
                </tr>
              </thead>
              <KBTableWithoutData
              hasData={coupons.length > 0}
              tableHeadNum="5"
              tipMessage="暂无优惠信息">

                {coupons &&
                coupons.map((item, index) => {
                  return (
                    <tr
                    key={index}
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.goToDetail(item.id)}>

                        <td>{(item.source || {}).name || ''}</td>
                        <td>{(item.creator || {}).name}</td>
                        <td>{item.title}</td>
                        <td>
                          <div>
                            {dayjs(item.start_date).format('YYYY年MM月DD日')}-
                            {dayjs(item.end_date).format('YYYY年MM月DD日')}
                          </div>
                        </td>

                        <td>
                          <div>
                            普通会员：
                            <span>{item.price}（原价）</span>
                            <ArrowRightOutlined
                          style={{ marginRight: 5 }} />

                            {item.price > Math.abs(item.discount_price) ?
                          item.price - Math.abs(item.discount_price) :
                          0}
                            （终价）
                          </div>
                          <div style={{ color: '#fa689a' }}>
                            办公楼会员：
                            <span>{item.tenant_price}（原价）</span>
                            <ArrowRightOutlined
                          style={{ marginRight: 5 }} />

                            {item.tenant_price >
                          Math.abs(item.discount_tenant_price) ?
                          item.tenant_price -
                          Math.abs(item.discount_tenant_price) :
                          0}
                            （终价）
                          </div>

                          <div style={{ color: '#fa689a' }}>
                            奕桥会员：
                            <span>{item.bridge_price || 0}（原价）</span>
                            <ArrowRightOutlined
                          style={{ marginRight: 5 }} />

                            {item.bridge_price >
                          Math.abs(item.discount_bridge_price) ?
                          item.bridge_price -
                          Math.abs(item.discount_bridge_price) :
                          0}
                            （终价）
                          </div>
                          <span
                        style={{ textDecoration: 'line-through' }}>
                        </span>
                        </td>
                      </tr>);

                })}
              </KBTableWithoutData>
            </table>
            <KBPagination
            pagination={pagination}
            template={pageTemplate} />

          </div>
          {modalVisible &&
          <SettingCoupon
          source_type={pageType === 'coupon' ? 'meeting' : 'desk'}
          type={'edit'}
          close={() => this.setState({ modalVisible: false })}
          open={modalVisible}
          data={currentData}
          callback={(id, params, type) => {
            this.updateCoupon(id, params, type);
          }} />}


        </section>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { location: { pathname, query } = {} } = props;
  const path = pathname.split('/');
  const pageType = path[path.length - 1];
  let page = parseInt(query && query.page, 10);
  page = isNaN(page) ? 1 : page;
  return { pageType, page };
}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingCoupon);
